/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback, useState } from "react";
import { BEM } from "@adapptio/lib-components";
import { FieldButton, FieldGroup, FieldText, IFieldTextProps } from "@adapptio/lib-editor-ui";
import { COLOR } from "@adapptio/lib-editor-ui/src/enums/COLOR";

import "./InspectorNodeMapAdd.scss";
import { isFunction } from "@adapptio/lib-shared";

export interface IInspectorNodeMapAddProps {
	className?: string;
	onSubmit?: (value: string) => void;
}

export const InspectorNodeMapAdd: React.FC<IInspectorNodeMapAddProps> = ({ className, onSubmit }) => {
	const baseClass = BEM("edt-inspector-node-map-add");
	const [ inputValue, setInputValue ] = useState("");

	const handleInputChange = useCallback<IFieldTextProps["onChange"]>(
		(value) => {
			setInputValue(value);
		},
		[ setInputValue ]
	);

	const handleSubmit = useCallback(() => {
		if (isFunction(onSubmit)) {
			onSubmit(inputValue);
		}

		setInputValue("");
	}, [ inputValue, onSubmit, setInputValue ]);

	if (className) {
		baseClass.add(className);
	}

	baseClass.add("edt-inspector-node-list-item");

	return (
		<FieldGroup className={baseClass.toClassName()}>
			<FieldText
				value={inputValue}
				onChange={handleInputChange}
				onPressEnter={handleSubmit}
			/>
			<FieldButton
				color={COLOR.INFO}
				className={baseClass.element("submit-btn").toClassName()}
				onClick={handleSubmit}
				disabled={!inputValue}
			>
				Add
			</FieldButton>
		</FieldGroup>
	);
};
